<template>
	<v-dialog v-model="isDialogOpen" :max-width="400" transition="dialog-transition" content-class="app-dialog could-not-invite-dialog">
		<div class="display-flex flex-column align-center">
			<div class="dialog-title">{{ notInvitedEmails.join(', ') }} could not be invited to your account</div>
			<div class="my-2">For additional info contact us at <a href="mailto:team@ply.io" class="link-style">team@ply.io</a></div>

			<v-btn depressed color="primary" height="40" class="mt-2" @click="isDialogOpen = false">Got it</v-btn>
		</div>
	</v-dialog>
</template>

<script>
export default {
	name: 'CouldNotInviteDialog',
	components: {},
	props: {
		isShowDialog: { type: Boolean },
		notInvitedEmails: { type: Array },
	},

	watch: {
		isShowDialog: {
			handler(isOpen) {
				this.isDialogOpen = isOpen;
			},
		},
		isDialogOpen: {
			handler(isOpen) {
				this.$emit('update:isShowDialog', isOpen);
				this.comboboxSelection = [];
				this.showSendInviteDialog = false;
			},
		},
	},
	data: () => ({
		isDialogOpen: false,
	}),
};
</script>

<style scoped lang="scss">
.could-not-invite-dialog {
	> div {
		padding: 0 20px 20px 20px;
	}

	.dialog-title {
		text-align: center;
		font-weight: 500;
	}
}
</style>
